import { useState } from "react";
import "../styles/inputGB.css";

export const InputGB = (props) => {
  let { required = false, type = "text", error = false } = props;
  const [typeState, setTypeState] = useState(type);
  const [errorValidate, setErrorValidate] = useState(error);

  const handleChange = (e) => {
    let value = e.target.value;

    // Validar si el tipo es "number" y evitar números negativos
    if (typeState === "number" && value < 0) {
      value = ""; // Limpiar el valor si es negativo
    }

    e.target.value === ""
      ? setErrorValidate(true)
      : setErrorValidate(false);
    
    props.onChange({ ...e, target: { ...e.target, value } });
  };

  return (
    <div className="div-inputGB flex flex-col justify-center">
      <label className="inputGB-label global-font">{props.label}</label>
      <div
        className="inputGB-div flex row-auto justify-center"
        style={{
          borderColor: errorValidate ? "red" : "rgb(0, 78, 119)"
        }}
      >
        <input
          className="inputGB items-center"
          required={required}
          onBlur={() => {
            props.value === "" ? setErrorValidate(true) : setErrorValidate(false);
          }}
          onChange={handleChange}
          type={typeState}
          placeholder={props.placeholder}
          value={props.value}
          accept={props.accept}
        />
      </div>
    </div>
  );
};
